import { useState } from 'react';

import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useCheckMobileScreen } from '../../hooks';
import PrimaryButtonV2 from '../../components/UI/Buttons/PrimaryButtonV2';
import styles from './Chat.module.scss';
import useMediaRecorder from '../../hooks/useMediaRecorder';
import { AudioVisualizer } from '../../components/UI/AudioVisualizer/AudioVisualizer';
import { useTranslation } from '../../hooks/useTranslations';
// import { convertToRaw, EditorState } from 'draft-js';
// import { Editor } from "react-draft-wysiwyg";

const ChatFooter = ({
  handleTextinput,
  handleTyping,
  sendMessage,
  newMessage,
  userIsTyping,
  currentConversation,
}: any) => {
  const [uploadedFile, setUploadedFile] = useState<Array<any>>([]);
  // const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty());
  const { translations } = useTranslation();
  const MAX_FILE_SIZE = 2000000; //2MB
  const isMobile = useCheckMobileScreen();
  const location = useLocation();
  const showSentIcon = Boolean(location.pathname.includes('/web/video-call') || isMobile);
  const { clearRecording, recordedBlob, status, streamRef, recordedUrl } =
    useMediaRecorder('audio');

  const handleSubmit = () => {
    if (newMessage.trim().length !== 0) {
      const messageObject = {
        type: 'T',
        payload: newMessage,
        // eslint-disable-next-line
        message_external_identifier: Number(new Date()).toString(36),
      };
      sendMessage(messageObject);
    }
    if (uploadedFile.length > 0) {
      if (uploadedFile[0].size > MAX_FILE_SIZE) {
        toast.error(translations('large_file_error').toString(), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return;
      }
      const messageObject = {
        type: 'file',
        mimeType: uploadedFile[0].type,
        fileName: uploadedFile[0].name,
        payload: uploadedFile[0],
        // eslint-disable-next-line
        message_external_identifier: Number(new Date()).toString(36),
      };
      sendMessage(messageObject);
      setUploadedFile([]);
    }
  };

  const handleEnter = (e: any) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    } else {
      handleTyping();
    }
  };

  const deleteFile = (index: number) => {
    const filteredData = uploadedFile.filter((el, i) => i !== index);
    setUploadedFile([...filteredData]);
  };

  return (
    <div className={styles.wrap}>
      {currentConversation?.conversation_status !== 'C' && (
        <div className={styles.chatFooter}>
          {userIsTyping?.typing &&
            userIsTyping.conversation_id === currentConversation.conversation_id ? (
            <div
              className={styles.typing}
            >{`${userIsTyping.user.name} ${userIsTyping.user.lastName} ${translations('videoCall.typing')}`}</div>
          ) : null}
          <div className={styles.dFlex}>
            {recordedBlob ? (
              <div className={styles.audioWrapper}>
                <i onClick={clearRecording} className={styles.removeIcon} />
                <audio src={recordedUrl} controls />
              </div>
            ) : null}
            {uploadedFile.length > 0 ? (
              <div className={styles.filesWrap}>
                {uploadedFile.map((file, i) => (
                  <div className={styles.file} key={i}>
                    <i onClick={() => deleteFile(i)} className={styles.removeIcon} />
                    <p>{file.name}</p>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
          {status === 'recording' && streamRef ? (
            <div className={styles.audioVisualizer}>
              <AudioVisualizer audioStream={streamRef.current} />
            </div>
          ) : null}
          <div className={styles.dFlex}>
            <div className={styles['text-box']}>
              <textarea
                maxLength={500}
                disabled={currentConversation.conversation_status === 'C'}
                placeholder={translations('message').toString()}
                rows={4}
                cols={50}
                onChange={(e) => handleTextinput(e.target.value)}
                onKeyDown={handleEnter}
                value={newMessage}
              ></textarea>
              {/* <label htmlFor="file-upload" className={styles.inputFiles}>
                                <img src={attachFile} alt="plus" />
                            </label>
                            <input multiple id="file-upload" type="file" onChange={(e) => uploadFile(e)} disabled={currentConversation.conversation_status === "C"}
                            />
                            <i onClick={handleVoiceRecord} className={styles.micOnIcon}></i> */}
              {showSentIcon && (
                <button className={styles.sentButton} onClick={handleSubmit}>
                  <i className={styles.sentIcon}></i>
                </button>
              )}
            </div>

            {!showSentIcon && (
              <PrimaryButtonV2
                disabled={currentConversation.conversation_status === 'C'}
                text={translations('send')}
                onClick={handleSubmit}
                containerStyle={{
                  alignItems: 'center',
                }}
                buttonStyle={{
                  minWidth: 80,
                  fontSize: 14,
                  height: 40,
                }}
              ></PrimaryButtonV2>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatFooter;
